var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{staticClass:"profile-settings-modal",attrs:{"height":"600","show":_vm.show},on:{"close":_vm.close}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n    "+_vm._s(_vm.$t("avatarProfilePicture"))+"\n  ")]),_c('avatar-profile-picture',{attrs:{"childId":_vm.fromBus.childId},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }